<template>
	<b-modal id="modal-confirm" centered hide-footer hide-header>
		<p class="modal-confirm-text mb-4">
			Você tem certeza que deseja
			<strong>{{ type == "contact" ? "excluir esse contato?" : "excluir esse documento?" }}</strong>
		</p>
		<b-row>
			<b-col class="p-2" cols="12" md="6">
				<button class="btn btn-secondary btn-modal" @click="remove">SIM</button>
			</b-col>
			<b-col class="p-2" cols="12" md="6">
				<button class="btn btn-primary btn-modal" @click="$bvModal.hide('modal-confirm')">NÃO</button>
			</b-col>
		</b-row>
	</b-modal>
</template>
<script>
	export default {
		name: "ConfirmModalComponent",
		props: ["type"],
		methods: {
			remove: async function () {
				this.$bvModal.hide("modal-confirm");
				if (this.type == "contact") {
					this.$store.dispatch("removeContact");
				}

				if (this.type == "document") {
					if (this.$store.state.form.confirmModal.type == "uploadedDocuments") {
						await this.$store.dispatch("deleteDocumentFromServer", this.$store.state.form.confirmModal.key);
					}
					this.$store.dispatch("removeDocument");
				}
			},
		},
	};
</script>
<style lang="scss">
	.modal-content {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 4px 4px 35px 0 rgba(0, 0, 0, 0.14);
		border: none;
	}

	.modal-confirm-text {
		color: #32302f;
		font-family: "Montserrat";
		font-size: 20px;
		letter-spacing: -0.2px;
		line-height: 24px;
		text-align: center;
	}

	.modal-confirm-text > strong {
		font-size: 20px;
		font-weight: bold;
		white-space: pre;
	}

	#modal-confirm .modal-dialog {
		max-width: 400px;
	}

	.btn-modal {
		padding: 15px 0 !important;
		width: 100% !important;
	}
</style>
